import request from '@/http/request';

// 获取合作人员列表
export function getPartnerEmployeeList(params) {
  return request({
    url: '/api/v1/ops/partner_employee_list',
    method: 'get',
    params
  });
}

// 创建合作人员信息
export function createPartnerEmployee(data) {
  return request({
    url: '/api/v1/ops/partner_employee_create',
    method: 'post',
    data
  });
}

// 更新合作人员信息
export function updatePartnerEmployee(partnerId, data) {
  return request({
    url: `/api/v1/ops/partner_employee_update/${partnerId}`,
    method: 'put',
    data
  });
}

// 删除合作人员信息
export function deletePartnerEmployee(partnerId) {
  return request({
    url: `/api/v1/ops/partner_employee_delete/${partnerId}`,
    method: 'delete'
  });
}

// 根据合作人员ID获取详情
export function getPartnerEmployeeById(partnerId) {
  return request({
    url: `/api/v1/ops/partner_employee/${partnerId}`,
    method: 'get'
  });
}

// 根据合作人员ID查询操作日志
export function getPartnerEmployeeLogs(partnerId) {
  return request({
    url: `/api/v1/ops/partner_employee_logs/${partnerId}`,
    method: 'get'
  });
}